import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";

import { auth } from "../config/firebaseConfig";
import { AnimatedLoader } from "../components/Loaders/AnimatedLoader";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsAuthenticated(!!user);
    });

    return () => unsubscribe();
  }, []);

  const handleLoaderComplete = () => {
    setLoading(false);
  };

  if (loading) {
    return <AnimatedLoader onComplete={handleLoaderComplete} className="bg-linear-to-b nav-bar min-h-screen from-[#00363d] to-[#000f12]" />;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};
